export default __webpack_public_path__ + "static/media/Blue-Line-Patient.7002c7f2.svg";